import type {RegionConfig} from '../types/Locales'

// Конвертация ключевых слов в регулярное выражение.
export function makeRegexpFromKeywords(keywords: string | null, regionConfig: RegionConfig): RegExp | null {
    if (!keywords || keywords.trim().length === 0) {
        return null
    }
    // Заменяем запрещенные символы на пробелы, а пробелы на '.+'
    keywords = keywords.trim()
        .replace(/[.,:?*&(){}|#@$^[\]/\\-]/ug, ' ')
        .replace(/\s+/ug, '.+')
    return new RegExp(regionConfig.addLetterVariationsToKeywords(keywords), 'iu')
}
